export enum TemplateAvailabilityLevelTypes {
    GLOBAL = 'global',
    ORGANIZATION = 'organization',
    RELYING_PARTY = 'relyingParty'
}